module.exports = "/hwa/_next/static/images/plasterboard-dc50678b722f1e9f2ab10c46587e2222.png";